export const DEFAULT_MESSAGE = "Something went wrong";
